import React, { useRef, useState } from 'react';
import Tooltip from 'react-tooltip-portal';
import { FieldError } from 'react-hook-form';

export interface ITextInputCommonProps {
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    inputType?: 'text' | 'password';
    isRequired?: boolean;
    inputRef?: React.Ref<HTMLInputElement>;
    helperTip?: string;
    error?: FieldError | string;
    autoFocus?: boolean;
}

interface ITextInputBaseProps extends ITextInputCommonProps {
    name?: string;
    placeholder?: string;
    value?: string;
    maxLength?: number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const TextInputBase = (props: ITextInputBaseProps) => {
    const tooltipRef = useRef(null);
    const wrapperRef = useRef(null);
    const [overTooltip, setOverTooltip] = useState(false);
    const [hasFocus, setHasFocus] = useState(false);
    const [mounted, setMounted] = useState(false);

    React.useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    });

    let labelClass = 'label';
    labelClass += props.isRequired ? ' is-required' : '';
    labelClass += props.helperTip ? ' has-helper-tip' : '';

    let inputClass = 'input';
    if (props.error) {
        inputClass += ' has-error';
    }

    const errorPanel = () => {
        if (props.error && typeof props.error === 'string') {
            return <div>{props.error}</div>;
        } else {
            return <div>{(props.error as FieldError)?.message}</div>;
        }
    };

    if (!mounted) {
        return <></>;
    }

    return (
        <div className="dlc-form-textbox-wrapper2" style={props.style} ref={wrapperRef}>
            {props.label && (
                <label className={labelClass} htmlFor={props.name}>
                    {props.helperTip && (
                        <span
                            className="tool-tip"
                            ref={tooltipRef}
                            onMouseEnter={() => {
                                if (mounted) {
                                    setOverTooltip(true);
                                }
                            }}
                            onMouseLeave={() => {
                                if (mounted) {
                                    setOverTooltip(false);
                                }
                            }}
                        >
                            <i className="fa fa-info-circle" />
                        </span>
                    )}
                    <Tooltip active={overTooltip} parent={tooltipRef.current} position="top" className="tooltip">
                        <div>{props.helperTip}</div>
                    </Tooltip>
                    <Tooltip
                        active={props.error && hasFocus}
                        parent={wrapperRef.current}
                        position="bottom left"
                        className="form-validation-tooltip"
                        timeout={0}
                        hoverEvents={false}
                        tipStyle={{ pointerEvents: 'none' }}
                    >
                        {errorPanel()}
                    </Tooltip>
                    {props.label}
                </label>
            )}
            <input
                className={inputClass}
                name={props.name}
                id={props.name}
                ref={props.inputRef}
                placeholder={props.placeholder}
                onFocus={() => setHasFocus(true)}
                onBlur={() => setHasFocus(false)}
                onChange={props.onChange}
                onKeyDown={props.onKeyDown}
                autoFocus={props.autoFocus}
                maxLength={props.maxLength}
            />
        </div>
    );
};

export default TextInputBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/TextInputBase.redesign.tsx